<template>
  <div id="appstatusquery">
    <!-- PC端 -->
    <div class="PC">
      <div class="top"><img src="../assets/img/logo2.png" alt="" /></div>
      <div class="content">
        <div class="dialog-title">审核状态查询</div>
        <div class="goBack" @click="goBack()">
          <i class="el-icon-d-arrow-left"></i>
          返回
        </div>
        <!-- 申请状态:验证身份,重置密码 -->
        <div class="verification">
          <div class="verification_outer">
            <div class="ver1">
              <div class="ver1_l">
                <div class="ver1_l_c"></div>
              </div>
              <div class="ver1_center"></div>
              <div :class="{ ver1_l: true, ver1_l_bg: status == '0' }">
                <div
                  :class="{ ver1_l_c: true, ver1_l_c_bg: status == '0' }"
                ></div>
              </div>
            </div>
            <div class="ver2">
              <span>验证身份</span>
              <span class="ver_word">查询结果</span>
            </div>
          </div>
        </div>
        <!-- 身份信息查询 -->
        <div class="dialog-content" v-if="status == '0'">
          <div class="line">
            <div class="value">
              <div class="title">身份信息</div>
              <el-input
                v-model="input"
                placeholder="请输入手机号 / 身份证号"
                clearable
                @keyup.enter.native="queryStatus"
              ></el-input>
            </div>
            <div class="line_word">
              <img src="../assets/img/jg.png" alt="" />
              <span>请输入在资料申请中提交的信息</span>
            </div>
          </div>
          <div class="dialog-but">
            <div class="title"></div>
            <div class="valuebtn" @click="queryStatus">
              <span>下一步</span>
            </div>
          </div>
        </div>
        <!-- 审核通过 -->
        <div class="content_box" v-if="status == '2'">
          <img class="one" src="../assets/img/shtg.png" alt="" />
          <div class="two">审核通过</div>
          <!-- <div class="three">短信已经发送通知</div> -->
          <div class="four">
            <div
              :class="{
                four_outer: true,
                four_outer_2: status == '2',
              }"
            >
              <div class="four_left">
                <img src="../assets/img/shtgxtb.png" alt="" />
              </div>
              <div class="four_right">
                <div class="rightword">已成功！</div>
                <div class="rightinfo">恭喜你,你已经审核通过。</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 审核拒绝 -->
        <div class="content_box" v-if="status == '3'">
          <img class="one" src="../assets/img/shjj.png" alt="" />
          <div class="two">审核不通过</div>
          <div class="three">申请信息错误</div>
          <div class="four">
            <div :class="{ four_outer: true, four_outer_3: status == '3' }">
              <div class="four_left">
                <img src="../assets/img/shjjxtb.png" alt="" />
              </div>
              <div class="four_right">
                <div class="rightword">请注意</div>
                <div class="rightinfo">
                  {{ refuseReason }}
                </div>
              </div>
            </div>
          </div>
          <div class="five">
            <div class="five_btn" @click="reApply">重新申请</div>
          </div>
        </div>
        <!-- 等待审核 -->
        <div class="content_box" v-if="status == '1'">
          <img class="one" src="../assets/img/ddsh.png" alt="" />
          <div class="two">等待审核</div>
          <div class="three">请耐心等待</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      flag: 0,
      status: "0", //审核状态
      input: "",
      refuseReason: "", //审核状态查询返回的原因
    };
  },
  methods: {
    start() {
      if (window.screen.width / window.screen.height > 1) {
        this.flag = 1;
      } else {
        this.flag = 2;
        // this.$message({
        //   type: "warning",
        //   message: "请用电脑端查看!",
        // });
        // return;
      }
    },
    /* 根据身份证号码查询申请状态 */
    queryStatus() {
      let requestData = {
        id: sessionStorage.getItem("ID"),
        search: this.input,
      };

      this.$request(
        "post",
        "/enrollInfo/getCheckStatus",
        requestData,
        (data) => {
          console.log("根据身份证号码查询申请状态", data);
          this.status = data.status;
          let refuseReason = data.refuseReason;
          if (refuseReason == "" || refuseReason == null) {
            refuseReason =
              "你所提交的信息已经审核失败，你的学籍表出现错误，如有疑问，请联系客服人员。";
            this.refuseReason = refuseReason;
          } else {
            this.refuseReason = refuseReason;
          }

          this.$message({
            message: "查询成功",
            type: "success",
          });
        }
      );
    },
    //返回上一步操作
    goBack() {
      this.$router.push("/dataRequest");
    },
    // 重新提交 跳转至资料填写界面 即flag = 1
    reApply() {
      // 根据学生ID查询当前学生为应届毕业生还是历届毕业生  应届毕业生跳转至freshgraduate界面 历届毕业生跳转至formerstudents界面
      this.$request(
        "post",
        "/student/getGraduating",
        { studentId: sessionStorage.getItem("ID") },
        (data) => {
          if (data.graduating == "1" || data.graduating == 1) {
            // 应届毕业生
            this.$router.push("/freshgraduate?flag=1");
          } else {
            // 历届毕业生
            this.$router.push("/formerstudents?flag=1");
          }
        }
      );
    },
  },
  mounted() {
    this.start();
  },
};
</script>

<style lang="less" scoped>
#appstatusquery {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* PC端 */
  .PC {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: rgba(245, 245, 245, 1);
    .top {
      width: 25rem;
      height: 5rem;
      box-sizing: border-box;
      margin: 10px 0;

      > img {
        width: 100%;
        height: 100%;
      }
    }
    .content {
      border-radius: 10px;
      width: 80%;
      max-width: 1200px;
      height: 70%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: rgba(255, 255, 255, 1);
      position: relative;
      .dialog-title {
        width: 80%;
        height: 50px;
        line-height: 50px;
        font-size: 17px;
        font-weight: 700;
        border-bottom: 1px solid rgba(204, 204, 204, 1);
      }
      .goBack {
        position: absolute;
        left: 15px;
        top: 15px;
        font-size: 15px;
        &:hover {
          cursor: pointer;
        }
      }

      .verification {
        width: 100%;
        height: 3.75rem;
        display: flex;
        justify-content: center;
        margin: 30px 0 20px 0;
        font-size: 14px;
        .verification_outer {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          align-items: center;

          .ver1 {
            width: 63%;
            display: flex;
            align-items: center;
            margin-right: 17px;
            .ver1_l {
              width: 15px;
              height: 15px;
              border-radius: 50%;
              background: rgba(152, 188, 255, 1);
              display: flex;
              justify-content: center;
              align-items: center;

              .ver1_l_c {
                width: 9px;
                height: 9px;
                border-radius: 50%;
                background: rgba(51, 125, 255, 1);
              }
            }
            .ver1_l_bg {
              width: 15px;
              height: 15px;
              border-radius: 50%;
              background: rgba(229, 229, 229, 1);
              display: flex;
              justify-content: center;
              align-items: center;

              .ver1_l_c_bg {
                width: 9px;
                height: 9px;
                border-radius: 50%;
                background: rgba(166, 166, 166, 1);
              }
            }
            .ver1_center {
              flex: 1;
              height: 8px;
              background: rgba(224, 241, 255, 1);
            }
          }
          .ver2 {
            width: 70%;
            display: flex;
            justify-content: space-between;
            > span {
              letter-spacing: 1px;
            }
            .ver_word {
              margin-right: 14px;
            }
          }
        }
      }
      .content_box {
        width: 100%;
        height: 340px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .outer {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          .outer_word {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 2px;
            box-sizing: border-box;
            margin: 20px 0 8px 0;
            color: rgba(0, 0, 0, 1);
          }
          .outer_bottom {
            width: 100%;
            height: 15px;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            margin: 15px 0;
            > img {
              width: 9px;
              height: 9px;
            }
            > span {
              font-size: 10px;
              font-weight: 400;
              letter-spacing: 2px;
              color: rgba(153, 153, 153, 1);
            }
          }
        }
        .one {
          width: 70px;
          height: 70px;
          box-sizing: border-box;
          margin: 19px 0 26px 0;
        }
        .two {
          font-size: 18px;
          font-weight: 600;
        }
        .three {
          font-size: 12px;
          font-weight: 400;
          box-sizing: border-box;
          margin: 25px 0 20px 0;
          color: rgba(166, 166, 166, 1);
        }
        .four {
          width: 63%;
          display: flex;
          justify-content: center;
          .four_outer {
            width: 100%;
            height: 100px;
            box-sizing: border-box;
            border-radius: 2px;

            display: flex;
            margin-right: 17px;
            .four_left {
              width: 64px;
              height: 100%;
              box-sizing: border-box;
              padding: 16px 0 0 24px;
              > img {
                width: 21px;
                height: 21px;
              }
            }
            .four_right {
              width: 85%;
              height: 100%;
              display: flex;
              flex-direction: column;
              box-sizing: border-box;
              padding-top: 16px;
              align-items: flex-start;

              .rightword {
                font-size: 16px;
                font-weight: 600;
                color: rgba(0, 0, 0, 0.85);
                margin-bottom: 4px;
              }
              .rightinfo {
                font-size: 14px;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.65);
                text-align: left;
              }
            }
          }
          .four_outer_2 {
            background: rgba(246, 255, 237, 1);
            border: 1px solid rgba(183, 235, 143, 1);
          }
          .four_outer_3 {
            background: rgba(255, 251, 230, 1);
            border: 1px solid rgba(255, 229, 143, 1);
          }
        }
        .five {
          width: 63%;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 15px;
          .five_btn {
            width: 200px;
            height: 32px;
            opacity: 1;
            border-radius: 5px;
            background: rgba(0, 79, 146, 1);
            font-size: 14px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            display: flex;
            justify-content: center;
            align-items: center;
            &:hover {
              cursor: pointer;
            }
          }
        }
      }
      .dialog-content {
        width: 100%;
        height: 90%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;

        .line {
          width: 100%;
          height: 2.625rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-top: 10px;

          .value {
            width: 63%;
            height: 43px;
            position: relative;
            margin-right: 17px;
            .title {
              position: absolute;
              left: -70px;
              top: 10px;
              font-size: 14px;
            }
          }
          .line_word {
            width: 63%;
            display: flex;
            margin-top: 5px;
            align-items: center;
            > img {
              width: 12px;
              height: 12px;
            }
            > span {
              margin-left: 5px;
              font-size: 12px;
              font-weight: 400;
              letter-spacing: 2px;
              color: rgba(153, 153, 153, 1);
            }
          }
        }
        .dialog-but {
          width: 100%;
          height: 2.8125rem;
          box-sizing: border-box;

          display: flex;
          justify-content: center;
          align-items: flex-start;
          margin: 50px 17px 0 0;
          .valuebtn {
            width: 63%;
            height: 43px;
            background: rgba(7, 80, 139, 1);
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 8px;
            &:hover {
              cursor: pointer;
            }
            > span {
              color: #fff;
            }
          }
        }
      }
    }
  }
}
</style>
